export default __webpack_public_path__ + "static/express_2-4cdd4791bf8491cba069f9db79b1f102.png";